export const GUARD_SOS_EVENT = 'SosTriggered'
export const CLIENT_SOS_EVENT = 'ClientSosTriggered'

export function isClientSosEvent(event: string): boolean {
  return event === CLIENT_SOS_EVENT
}

export function isSosEvent(event: string): boolean {
  return event === GUARD_SOS_EVENT || event === CLIENT_SOS_EVENT
}
